import React, { useContext, useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { defineMessages, useIntl } from 'react-intl';
import { useLocation, useHistory } from 'react-router-dom';
import { parse, stringify } from '../../../utils/UrlUtil';
import useSubscriptionExpiredRestrictions from '../../../hooks/useSubscriptionExpiredRestrictions';
import { AccountContext } from '../../../components/AccountContext';

const messages = defineMessages({
  add: { id: 'menu.add_assessment_template', defaultMessage: 'Add Assessment Template' },
});

const AssessmentTemplateListHeader = () => {
  const { formatMessage } = useIntl();
  const currentAccount = useContext(AccountContext);
  const location = useLocation();
  const history = useHistory();
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  const params = parse(location.search);

  const [filter, setFilter] = useState({ ...params.filter });

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  const onQueryVariableChange = () => {
    const params = parse(location.search);

    // build the filter
    const newFilter = {
      ...params.filter,
      ...filter,
    };

    const search = stringify({
      ...params,
      filter: newFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  };

  /**
   * Update the filter Query.
   */
  const onChangeQueryText = (event) => {
    const updatedFilter = {
      ...filter,
      query: event.currentTarget.value,
    };

    setFilter(updatedFilter);
  };

  return (
    <div className="p-grid">
      <div className="p-col">
        <div className="p-inputgroup">
          <InputText
            value={filter.query}
            onChange={onChangeQueryText}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                onQueryVariableChange();
              }
            }}
          />
          <Button icon="pi pi-search" onClick={onQueryVariableChange} />
        </div>
      </div>
      <div className="p-col align-right">
        <Button
          label={formatMessage(messages.add)}
          icon="fa fa-plus"
          disabled={subscriptionIsExpired}
          onClick={() => history.push(`/accounts/${currentAccount}/assessments/templates/new`)}
        />
      </div>
    </div>
  );
};

export default AssessmentTemplateListHeader;
